module.exports = __webpack_public_path__ + "static/media/audio.938aaf8d.svg";